import { render, staticRenderFns } from "./UmesrCRUD.vue?vue&type=template&id=1b03c023"
import script from "./UmesrCRUD.vue?vue&type=script&lang=js"
export * from "./UmesrCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b03c023')) {
      api.createRecord('1b03c023', component.options)
    } else {
      api.reload('1b03c023', component.options)
    }
    module.hot.accept("./UmesrCRUD.vue?vue&type=template&id=1b03c023", function () {
      api.rerender('1b03c023', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/umesr/UmesrCRUD.vue"
export default component.exports